import React, {Component} from 'react'
import PropTypes from "prop-types";

import SvGraphics from "../../assets/SvGraphics";

class UpdateFiles extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            fileForms: this.props.fileForms,
            addedFilesList:this.props.addedFilesList,
            selectedCategory:"",
            selectedFile: {},

        }
    }
    componentDidMount() {
/*        this.setState({
            addedFilesObj: this.props.addedFilesObj,
            addedFilesList: this.props.addedFilesList
        })*/
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    saveSelectedFile=(event)=>{
        this.setState({selectedFile:event})
    }

    saveSelectedCategory=(event)=>{
        this.props.onValueChange("selectFileCategory", event)
        this.setState({selectedCategory:event})
    }
    render() {
        let {t} = this.props

        let {entry,selectedCategory,selectedFile,fileForms}= this.state
let addedFilesList=this.props.addedFilesList
        let language = localStorage.getItem('language')
        let fromLanguage
        if (language === "he") {
            fromLanguage= "Form_desc_he"
        }else{
            fromLanguage= "Form_desc"

        }
        let forms= fileForms.map(item=> {
                return <option value={item.Form_type_ID}>{item[fromLanguage]}</option>
            }
        )
        let addedFiles=[]


        addedFiles= addedFilesList.map((item,index)=>{
            return (
                <div className={'patientsFormRow-uploadFiles'}>
                    <label className={'uploaded-files-label-category'}>{item.Form_type.Form_desc_he}</label>
                    <a href={item.Form_url} target="_blank" className={'uploaded-files-label-view'}>View uploaded file</a>
                    <SvGraphics className={'uploaded-files-label-button'}
                                onClick={() => this.props.deleteUploadedFile(index)} svgname={'delete-icon'}/>
                </div>
            )
        })


        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <select className={'selectBox'} id="selectFileCategory" name="selectFileCategory" value={selectedCategory}
                                onChange={(event)=>this.saveSelectedCategory(event.target.value)}>
                            <option/>
                            {forms}
                        </select>
                    </div>
                        <input className={'chooseFileStyle'} type="file" name="image_uploads" id="file-input" onChange={(event)=>this.saveSelectedFile(event.target)}/>

                    {!this.props.isUploadingFiles&&<div className={'buttonStyle'}>
                        <div
                            onClick={() => this.props.addFileObj(addedFilesList.length, selectedCategory, selectedFile)}>{t('patient_boarding.addFile')}</div>
                    </div>}

                    { this.props.isUploadingFiles&& <div className="loader-uploadfiles"/>}


                </div>


                 {addedFiles}

                <div className={'blankSpace'}/>
            </div>

        )
    }
}

UpdateFiles.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default UpdateFiles;
